<template>
  <div class="page-box">
    <div class="state-ul">
      <div class="state-li" v-for="(item, index) in List" :key="index" :class="{ active: active === index }" @click="setActive(index)">{{ item }}</div>
    </div>
    <div class="study-box">
      <div class="study-top">
        <div class="duration-li">
          <div class="duration-h">{{ duration }}<span>分钟</span></div>
          <div class="duration-p">学习总时长</div>
        </div>
        <div class="duration-li">
          <div class="duration-h">{{ lessons }}<span>节</span></div>
          <div class="duration-p">已学习课程</div>
        </div>
      </div>
      <!--学习中-->
      <div v-if="active === 0">
        <StudyList :list2="List2" :page="page" @sizeChange="sizeChange" @currentChange="currentChange"/>
      </div>
      <div v-if="active === 1">
        <StudyList2 :list2="List3" :page="page" @sizeChange="sizeChange" @currentChange="currentChange"/>
      </div>
      <!--已看完-->
    </div>
  </div>
</template>

<script>
import StudyList from "@/views/PersonalCenter/components/StudyList.vue";
import StudyList2 from "@/views/PersonalCenter/components/StudyList2.vue";
import { getLearningProgress, getUserLearningProgress } from '@/api/user'
export default {
  name: "LearningProgress",
  components: {
    StudyList,
    StudyList2
  },
  data() {
    return {
      active: 0,
      duration: 0,
      lessons: 0,
      List: [
        "学习中",
        "已看完"
      ],
      List2: [],
      List3: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      }
    }
  },
  methods: {
    setActive(index) {
      this.active = index;
      this.page.number = 1
      this.getLearningProgress()
    },
    // 分页查询学习进度
    getLearningProgress() {
      getLearningProgress({
        number: this.page.number,
        limit: this.page.limit,
        isComplete: this.active,
      }).then(res => {
        if (this.active === 0) {
          this.List2 = res.data
        } else {
          this.List3 = res.data
        }
        this.page.total = res.totalCount
      })
    },
    // 用户学习进度
    getUserLearningProgress() {
      getUserLearningProgress().then(res => {
        this.duration = res.data[0].durationCount
        this.lessons = res.data[0].courseCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getLearningProgress()
    },
    currentChange(value) {
      this.page.number = value
      this.getLearningProgress()
    },
  },
  mounted() {
    this.getLearningProgress()
    this.getUserLearningProgress()
  }
}
</script>

<style lang="less">
.study-top {
  border-radius: 10px;
  background: linear-gradient(222deg, #FF4F44 -1.87%, rgba(255, 180, 160, 0.00) 75.76%), #FF513A;
  display: flex;
  align-items: center;
  height: 84px;
  justify-content: center;
  color: #fff;

  .duration-li {
    text-align: center;
    width: 200px;

    .duration-h {
      font-size: 24px;
      font-weight: bold;
      line-height: 24px;
      margin-bottom: 6px;

      span {
        font-size: 12px;
        font-weight: normal;
        margin-left: 4px;
      }
    }

    .duration-p {
      font-size: 14px;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/LearningProgress.vue